import { CurrencySetting, Point } from "../../type";

export type AnimationPoint = {
  x: number;
  y: number;
  isIceBreak: boolean;
  isDropdownPoint: boolean;
  groupId: number;
  endId: number;
  win: number;
  beforeWin?: number;
};

export type Multiply = {
  x: number;
  y: number;
  value: number;
};

export type GoldRushBonanzaGameData = {
  category: number;
  animationPoints?: AnimationPoint[];
  totalMultiplier: number;
  preMultiplier: number;
  // triggeredFeatureSymbolId: FeatureSymbols;
  triggeredFeaturePoint?: Point;
  playWin?: number;
  // candyBaySymbolIds?: number[];
  // rocketDirection: "None" | "Horizontal" | "Vertical";
  multiplys: Multiply[];
};

export enum Symbols {
  Spades = 201,
  Hearts = 202,
  Clubs = 203,
  Diamonds = 204,
  Ace = 101,
  King = 102,
  Queen = 103,
  Jack = 104,

  Multiplier = 600,
}

export enum FeatureSymbols {
  None = 0,
  IceValue = 1,
  Bomb = 5,
  GummyRocket = 4,
  Chocolate = 3,
  MysterySweet = 2,
  RocketRocket = 44,
  ChocolateChocolate = 33,
  MysterySweetSweet = 22,
  RocketChocolate = 43,
  RocketMysterySweet = 42,
  ChocolateMysterySweet = 32,
  SugarBlast = 8,
  IceBomb = 7,
}

export type Rule = {
  buyFreeSpinRate: number;
  payouts: { [k: string]: number };
  givenFreeSpin: { [k: string]: number };
};

export type Setting = {
  currencies: CurrencySetting[];
  payouts: { [k: string]: number };
  buyFreeSpinRate: number;
};
